import PropTypes from 'prop-types'
import { useNavigate, useMatch } from 'react-router'
import { SidebarItemButton, SidebarIconContainer } from './styled-components'

const SidebarItem = ({ to, label, Icon }) => {
  const navigate = useNavigate()
  const match = useMatch({ path: to, end: false })
  const active = Boolean(match)

  return (
    <SidebarItemButton type="button" $active={active} onClick={() => navigate(to)}>
      <SidebarIconContainer $active={active}>
        <Icon size={18} />
      </SidebarIconContainer>
      {label}
    </SidebarItemButton>
  )
}

SidebarItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
}

export default SidebarItem
